import React from "react";
import { useTranslation } from "react-i18next";
import { Group, group } from "@planzone/dto";
import { useAddResourceGroup } from "@planzone/view-models";
import { Button } from "@common/button";
import { Modal } from "@common/modal";
import { Props } from "./types";
import { GroupCreationForm } from "./groupCreationForm";
import styles from "./styles.scss";

function ProjectGroupCreation({ project, cancel }: Props) {
  const { isRequestPending, addResourceGroup } = useAddResourceGroup(
    project.uuid,
  );
  const { t } = useTranslation();
  const [formData, setFormData] = React.useState<Group>({
    ...group,
    resourceType: "project",
  });

  return (
    <Modal header={t("addResourceGroup.title")} close={cancel}>
      <form
        onSubmit={(event) => {
          event.preventDefault();
          addResourceGroup({ namespace: project.uuid, group: formData });
        }}
        className={styles.main}
      >
        <div className={styles.form}>
          <GroupCreationForm
            project={project}
            formData={formData}
            editForm={setFormData}
          />
        </div>
        <div className={styles.buttons}>
          <Button type="cancel" press={cancel}>
            {t("addResourceGroup.cancel")}
          </Button>
          <Button type="submit" status={isRequestPending ? "pending" : "none"}>
            {t("addResourceGroup.create")}
          </Button>
        </div>
      </form>
    </Modal>
  );
}

export { ProjectGroupCreation };
